export const PaymentMethod = {
  "money": "Dinheiro",
  "card_credit": "Cartão de Crédito",
  "card_debit": "Cartão de Débito",
  "pix": "PIX"
}